// extracted by mini-css-extract-plugin
var _1 = "ApplicantDecisionNote-moduleApplicantDecisionNote__OSKAG";
var _2 = "ApplicantDecisionNote-modulelabel__sLRdp";
export { _1 as "ApplicantDecisionNote", _2 as "label" }
